import React from "react";
import styles from "../Dashboard.module.css";

const ReportsCertificates = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Report Certificates</main>
    </div>
  );
};

export default ReportsCertificates;
